import { formatPatientRowData } from '../../../phan-he-kham-benh/utils/Utils';
import { formatBirthdate, formatDateTime } from '../../../utils/FormatUtils';

type Props = {
	patientInfo: any;
	className?: string;
};

const PatientRow = ({ patientInfo, className }: Props) => {
	const formatInsuranceInfo = (data: any) => {
		const insurancePercentage = data?.insCoveragePercentage
			? `(${patientInfo?.insCoveragePercentage}%)`
			: '';

		return data?.insCode ? `${data.insCode}${insurancePercentage}` : '...';
	};

	const formatAddressInfo = (data: any) => {
		return [
			data?.patientAddress,
			data?.patientCommuneName,
			data?.patientDistrictName,
			data?.patientProvinceName,
		]
			.filter((item) => item)
			.join(', ');
	};

	return (
		<div className={className}>
			<div className="d-flex">
				<div className="spaces fw-5 d-flex">
					<span className="d-inline-block fw-bold">Bệnh nhân:</span>
					<span className="spaces pl-4 fw-bold text-truncate">
						{patientInfo?.patientName
							? formatPatientRowData([
									patientInfo?.patientCode,
									patientInfo?.patientName,
									patientInfo?.patientGender,
									formatBirthdate(
										patientInfo?.patientAgeText,
										patientInfo?.patientDobYear
									),
									patientInfo?.visitObjectTypeName,
									patientInfo?.visitCode,
							  ])
							: '...'}
						,
					</span>
				</div>
				<div className="fw-5 d-flex spaces pl-4">
					<span className="fw-bold">Mã BHYT:</span>
					<span className="spaces pl-4 fw-bold text-truncate">
						{formatInsuranceInfo(patientInfo)}
					</span>
				</div>
			</div>

			<div className="d-flex justify-content-end">
				<div className="spaces fw-5 d-flex spaces">
					<span className="d-inline-block fw-bold">Thời điểm tới:</span>
					<span className="spaces pl-4 fw-bold text-truncate">
						{patientInfo?.visitStartedDate
							? formatDateTime(patientInfo?.visitStartedDate)
							: '...'}
					</span>
				</div>
				<div className="fw-5 d-flex">
					<span className="d-inline-block fw-bold">, Địa chỉ:</span>
					<span className="spaces pl-4 fw-bold text-truncate">
						{formatAddressInfo(patientInfo) || '...'}
					</span>
				</div>
			</div>
		</div>
	);
};

export default PatientRow;
